export const confirmDialogName = 'confirmDialogComponent';
